import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

/** Conta produtos ativos marcados como consignados (products.is_consigned).
 *  Usado como numerador do Índice de Consignado; o denominador (SKUs ativos)
 *  vem da base de linhas do dashboard. RLS já restringe por empresa. */
export function useConsignado() {
  const [count, setCount] = useState<number | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    async function run() {
      setLoading(true)
      const { count: c, error } = await supabase
        .from('products')
        .select('id', { count: 'exact', head: true })
        .eq('is_consigned', true)
        .eq('is_active', true)
        .is('deleted_at', null)
      if (cancelled) return
      setCount(error ? null : (c ?? 0))
      setLoading(false)
    }
    run()
    return () => { cancelled = true }
  }, [])

  return { consignadoCount: count, loading }
}
